import { c as _c } from "react/compiler-runtime";
import React from "react";
interface WaveWinnersApprovalErrorProps {
  readonly onRetry: () => void;
}
export const WaveWinnersApprovalError: React.FC<WaveWinnersApprovalErrorProps> = t0 => {
  const $ = _c(3);
  const {
    onRetry
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="tw-mb-0 tw-text-sm tw-font-medium tw-text-iron-300">Unable to load approved drops.</p>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onRetry) {
    t2 = <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-3 tw-px-4 tw-py-10 tw-text-center">{t1}<button type="button" onClick={onRetry} className="tw-rounded-lg tw-border tw-border-iron-600 tw-bg-iron-800 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-iron-100 tw-transition-colors hover:tw-border-iron-500 hover:tw-bg-iron-700 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-primary-400">Try again</button></div>;
    $[1] = onRetry;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};